import type { DeepRequired } from '../fixtures.types'

const lutherAddress: DeepRequired<LutherAddress> = {
  __typename: 'LutherAddress',
  address1: null,
  address2: null,
  address3: null,
  country: null,
  county: null,
  postcode: null,
  posttown: null,
  acre_property_id: null,
}

export default lutherAddress
